module.exports = __webpack_public_path__ + "static/img/16.76478717.jpg";